import React from 'react';
const icons = {
  close: (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <title>图片放大关闭</title>
      <desc>Created with Sketch.</desc>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="切图集合" transform="translate(-363.000000, -83.000000)">
          <g id="图片放大关闭" transform="translate(363.000000, 83.000000)">
            <circle id="Oval" fill-opacity="0.6" fill="#000000" cx="12" cy="12" r="12"></circle>
            <g
              id="Group-5"
              transform="translate(12.000000, 12.235702) rotate(-315.000000) translate(-12.000000, -12.235702) translate(6.500000, 6.735702)"
              stroke="#979797"
              stroke-linecap="round"
              stroke-linejoin="bevel"
              stroke-width="1.4">
              <path d="M-1.48029737e-16,5.33333333 L10.6666667,5.33333333" id="Line-3"></path>
              <path
                d="M3.10862447e-14,5.33333333 L10.6666667,5.33333333"
                id="Line-3-Copy"
                transform="translate(5.333333, 5.333333) rotate(-270.000000) translate(-5.333333, -5.333333) "></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  left: (
    <svg width="50px" height="50px" viewBox="0 0 50 50" version="1.1">
      <title>上一个</title>
      <desc>Created with Sketch.</desc>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="切图集合" transform="translate(-257.000000, -171.000000)">
          <g id="上一个" transform="translate(257.000000, 171.000000)">
            <circle id="Oval" fill-opacity="0.6" fill="#000000" cx="25" cy="25" r="25"></circle>
            <path
              d="M30.1998246,22 L29.182572,22 C29.1133988,22 29.0482946,22.0339084 29.0076045,22.0895182 L25.1542516,27.4009332 L21.3008988,22.0895182 C21.2602087,22.0339084 21.1951045,22 21.1259313,22 L20.1086787,22 C20.0205168,22 19.968976,22.1003689 20.0205168,22.1722548 L24.8029604,28.765408 C24.9765715,29.0041233 25.3319318,29.0041233 25.5041865,28.765408 L30.2866301,22.1722548 C30.3395273,22.1003689 30.2879865,22 30.1998246,22 Z"
              id="路径"
              stroke="#E0E0E0"
              stroke-width="0.8"
              fill="#E0E0E0"
              fill-rule="nonzero"
              transform="translate(25.153995, 25.472222) rotate(-270.000000) translate(-25.153995, -25.472222) "></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  leftDisabled: (
    <svg width="50px" height="50px" viewBox="0 0 50 50" version="1.1">
      <title>上一个置灰</title>
      <desc>Created with Sketch.</desc>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="切图集合" transform="translate(-452.000000, -171.000000)">
          <g
            id="上一个置灰"
            transform="translate(477.000000, 196.000000) scale(-1, 1) translate(-477.000000, -196.000000) translate(452.000000, 171.000000)">
            <circle
              id="Oval"
              fill-opacity="0.6"
              fill="#000000"
              transform="translate(25.000000, 25.000000) scale(-1, 1) translate(-25.000000, -25.000000) "
              cx="25"
              cy="25"
              r="25"></circle>
            <path
              d="M30.1998246,22 L29.182572,22 C29.1133988,22 29.0482946,22.0339084 29.0076045,22.0895182 L25.1542516,27.4009332 L21.3008988,22.0895182 C21.2602087,22.0339084 21.1951045,22 21.1259313,22 L20.1086787,22 C20.0205168,22 19.968976,22.1003689 20.0205168,22.1722548 L24.8029604,28.765408 C24.9765715,29.0041233 25.3319318,29.0041233 25.5041865,28.765408 L30.2866301,22.1722548 C30.3395273,22.1003689 30.2879865,22 30.1998246,22 Z"
              id="路径"
              stroke="#FFFFFF"
              stroke-width="0.8"
              fill="#FFFFFF"
              fill-rule="nonzero"
              opacity="0.2"
              transform="translate(25.153995, 25.472222) scale(-1, 1) rotate(-270.000000) translate(-25.153995, -25.472222) "></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  right: (
    <svg width="50px" height="50px" viewBox="0 0 50 50" version="1.1">
      <title>下一个</title>
      <desc>Created with Sketch.</desc>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="切图集合" transform="translate(-353.000000, -171.000000)">
          <g
            id="下一个"
            transform="translate(378.000000, 196.000000) scale(-1, 1) translate(-378.000000, -196.000000) translate(353.000000, 171.000000)">
            <circle id="Oval" fill-opacity="0.6" fill="#000000" cx="25" cy="25" r="25"></circle>
            <path
              d="M30.1998246,22 L29.182572,22 C29.1133988,22 29.0482946,22.0339084 29.0076045,22.0895182 L25.1542516,27.4009332 L21.3008988,22.0895182 C21.2602087,22.0339084 21.1951045,22 21.1259313,22 L20.1086787,22 C20.0205168,22 19.968976,22.1003689 20.0205168,22.1722548 L24.8029604,28.765408 C24.9765715,29.0041233 25.3319318,29.0041233 25.5041865,28.765408 L30.2866301,22.1722548 C30.3395273,22.1003689 30.2879865,22 30.1998246,22 Z"
              id="路径"
              stroke="#E0E0E0"
              stroke-width="0.8"
              fill="#E0E0E0"
              fill-rule="nonzero"
              transform="translate(25.153995, 25.472222) rotate(-270.000000) translate(-25.153995, -25.472222) "></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  rightDisabled: (
    <svg width="50px" height="50px" viewBox="0 0 50 50" version="1.1">
      <title>下一个置灰</title>
      <desc>Created with Sketch.</desc>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="切图集合" transform="translate(-554.000000, -171.000000)">
          <g id="下一个置灰" transform="translate(554.000000, 171.000000)">
            <circle
              id="Oval"
              fill-opacity="0.6"
              fill="#000000"
              transform="translate(25.000000, 25.000000) scale(-1, 1) translate(-25.000000, -25.000000) "
              cx="25"
              cy="25"
              r="25"></circle>
            <path
              d="M30.1998246,22 L29.182572,22 C29.1133988,22 29.0482946,22.0339084 29.0076045,22.0895182 L25.1542516,27.4009332 L21.3008988,22.0895182 C21.2602087,22.0339084 21.1951045,22 21.1259313,22 L20.1086787,22 C20.0205168,22 19.968976,22.1003689 20.0205168,22.1722548 L24.8029604,28.765408 C24.9765715,29.0041233 25.3319318,29.0041233 25.5041865,28.765408 L30.2866301,22.1722548 C30.3395273,22.1003689 30.2879865,22 30.1998246,22 Z"
              id="路径"
              stroke="#FFFFFF"
              stroke-width="0.8"
              fill="#FFFFFF"
              fill-rule="nonzero"
              opacity="0.2"
              transform="translate(25.153995, 25.472222) scale(-1, 1) rotate(-270.000000) translate(-25.153995, -25.472222) "></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  zoomOut: (
    <svg
      viewBox="64 64 896 896"
      focusable="false"
      data-icon="zoom-out"
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true">
      <path d="M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"></path>
    </svg>
  ),
  zoomIn: (
    <svg
      viewBox="64 64 896 896"
      focusable="false"
      data-icon="zoom-in"
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true">
      <path d="M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"></path>
    </svg>
  ),
  rotateLeft: (
    <svg
      viewBox="64 64 896 896"
      focusable="false"
      data-icon="rotate-left"
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true">
      <defs>
        <style></style>
      </defs>
      <path d="M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z"></path>
      <path d="M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z"></path>
    </svg>
  ),
  rotateRight: (
    <svg
      viewBox="64 64 896 896"
      focusable="false"
      data-icon="rotate-right"
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true">
      <defs>
        <style></style>
      </defs>
      <path d="M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z"></path>
      <path d="M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z"></path>
    </svg>
  ),
};
let preview = {
  previewMask: (
    <div>
      <svg
        viewBox="0 0 1098 1024"
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="currentColor">
        <path
          d={
            'M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z'
          }
        />
      </svg>
      预览
    </div>
  ),
  icons,
};
export { icons, preview };



// WEBPACK FOOTER //
// ./src/image/settings.js